import { render } from "./SchemaMarkupNumber.vue?vue&type=template&id=0540df56"
import script from "./SchemaMarkupNumber.vue?vue&type=script&lang=js"
export * from "./SchemaMarkupNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__